import { render, staticRenderFns } from "./ProyectoEdit.vue?vue&type=template&id=070211f4&scoped=true&"
import script from "./ProyectoEdit.vue?vue&type=script&lang=js&"
export * from "./ProyectoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070211f4",
  null
  
)

export default component.exports